import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const projectBaseUrl = `${Base_Url}/projectCat`;


export const projectCatList = async (params) => {
  let url = `${projectBaseUrl}/projectCatList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const addUpdateProjectCat = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${projectBaseUrl}${url}`, params);
    return res;
  };

//   const res = await postApiWithAuthenticated(`${projectBaseUrl}${url}`, params);
//   return res;
// };

export const ChangeStateStatus = async (id) => {
  let url = `${projectBaseUrl}/ChangeProjectCatrStatus?ProjectCatKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const getProjectCat = async (id) => {
    let url = `${projectBaseUrl}/getProjectCat?ProjectCatKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const ProjectCatLookupForWeb = async (id) => {
    let url = `${projectBaseUrl}/ProjectCatLookupForWeb`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


  export const GetProjectCatLookup = async () => {
    const url = `${projectBaseUrl}/ProjectCatLookup`;
  
    const res = await getListWithAuthenticated(url );
    return res;
  };